import { render, staticRenderFns } from "./BlankTemplateCard.vue?vue&type=template&id=7a60a5ea"
import script from "./BlankTemplateCard.vue?vue&type=script&lang=js"
export * from "./BlankTemplateCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports